<!-- @format -->

<info-index-tag>
    <div class="container_contents">
        <div class="container_breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item"><h1 class="heading-01 heading_information">会員情報</h1></li>
            </ul>
        </div><!--/.container_breadcrumb-->

        <div class="contents">

            <section class="contents_area">

                <div class="contents_block">

                    <p if={nodata} class="important_message margin-spacing-4_bottom">
                        本人確認書類が未提出です（お仕事の受託やクライアント様との交渉ができません）</p>

                    <h2 class="heading-03">会員情報</h2>

                    <div class="box_flex03 margin-spacing-2_top">
                        <div class="button button-secondary" type="button">
                            <a href="https://id.biz-samurai.com/i/info" target="_blank">
                                CROCO ID 会員登録情報へ
                            </a>
                        </div>
                    </div>
                    <p class="note align_c margin-spacing-1_top">※メールアドレス（ログインID）やパスワードは「CROCO
                        ID」のページで変更が可能です。</p>

                    <h2 class="heading-03 margin-spacing-4_top">登録基本情報</h2>

                    <p class="note align_c margin-spacing-1_top">
                        <a href="https://cro-co.co.jp/privacypolicy/agreement/"
                           target="_blank">※個人情報のお取り扱いについて</a>
                    </p>

                    <p class="note align_c margin-spacing-2_top"
                       if={nodata}
                    >
                        登録基本情報が登録されていません。以下のボタンから登録を行ってください。
                    </p>
                    <p class="note align_c margin-spacing-2_top"
                       if={!nodata && app}
                    >
                        現在、登録基本情報の更新を申請中です
                    </p>

                    <div class="box_flex03 margin-spacing-3_top">

                        <div if={(! nodata) && Object.keys(state.basic_information).length >= 2 }
                             class="button button-secondary" type="button" value=""
                             style="margin-left:1rem;margin-right:1rem;"
                             onclick={(e) => basicInfo()}>現在の内容を確認する
                        </div>

                        <div if={nodata} class="button button-secondary" type="button" value=""
                             style="margin-left:1rem;margin-right:1rem;"
                             onclick={(e) => basicInfoApplication()}>本人認証を行う
                        </div>

                        <div if={!nodata && !app} class="button button-secondary" type="button" value=""
                             style="margin-left:1rem;margin-right:1rem;"
                             onclick={(e) => basicInfoApplication()}>変更を申請する
                        </div>

                        <div if={!nodata && app} class="button button-secondary" type="button" value=""
                             style="margin-left:1rem;margin-right:1rem;"
                             onclick={(e) => basicInfoApplicationConfirm()}>申請内容を確認する
                        </div>

                    </div>

                    <h2 class="heading-03 margin-spacing-4_top">銀行口座情報</h2>

                    <p if={state.bank_account.status===0}
                       class="note align_c margin-spacing-2_top"
                    >
                        銀行口座情報が登録されていません。以下のボタンから登録を行ってください。
                    </p>
                    <p if={((!nodata || app) ) && state.bank_account.status===1}
                       class="note align_c margin-spacing-2_top"
                    >
                        現在内容を運営事務局で確認中のため、更新はできません
                    </p>
                    <p if={state.bank_account.status===2}
                       class="note align_c margin-spacing-2_top"
                    >
                        銀行口座情報に確認が必要な状態です。以下のボタンから更新画面へ移動し、内容を確認・修正してください。
                    </p>

                    <div class="box_flex03">
                        <div
                                if={state.bank_account.status!==1}
                                class="button button-secondary margin-spacing-3_top" type="button"
                                value="口座情報を変更する"
                                onclick={(e) => bankInfo()}>
                            {(state.bank_account.status === 0) ? "銀行口座情報を登録する" : "口座情報を変更する"
                            }
                        </div>
                        <div
                                if={state.bank_account.status===1}
                                class="button button-secondary margin-spacing-3_top" type="button"
                                value="内容を確認する"
                                onclick={(e) => bankInfoConfirm()}>
                            内容を確認する
                        </div>
                    </div>

                </div><!--/.contents_block-->

            </section><!--/.contents_area-->

        </div><!--/.contents-->
    </div><!--/.container_contents-->

    <script>
        import di from "dependency-injection";
        import invoiceProviderStateJname from "@tags/parts/info/invoice-provider-state-jname.riot";

        /**
         *                                         <input if={state.basic_information.sex === 1} class="text_input" type="text"
         *                                                name="sex" id="sex" placeholder="男性" readonly>
         *                                         <input if={state.basic_information.sex === 2} class="text_input" type="text"
         *                                                name="sex" id="sex" placeholder="女性" readonly>
         *                                         <input if={state.basic_information.sex === 3} class="text_input" type="text"
         *                                                name="sex" id="sex" placeholder="その他" readonly>
         *                                         <input if={state.basic_information.sex === 4} class="text_input" type="text"
         *                                                name="sex" id="sex" placeholder="無回答" readonly>
         */

        export default {
            components: {
                "invoice-provider-state-jname": invoiceProviderStateJname
            },
            app: false,
            nodata: true,
            SEX_JNAMES: {
                "name_1": "男性",
                "name_2": "女性",
                "name_3": "その他",
                "name_4": "無回答",
            },
            state: {
                bank_account: {status: 0},
                basic_information: {},
                eligible_invoice_provider: {state: 0}, //初期状態はstate＝0にする
                bank_account_confirm_button: "",
                bank_account_register_button: ""
            },
            ok(e) {
                this.api.request('basic-information', `ok`)
                    .then(data => location.reload())
                    .catch(err => alert(err));
            },
            basicInfo(e) {
                di.router.push('/info/basic-information');
            },
            bankInfo(e) {
                di.router.push('/info/bank-account');
            },
            bankInfoConfirm(e) {
                di.router.push('/info/bank-account-confirm');
            },
            basicInfoApplication(e) {
                di.router.push('/info/basic-information-application');
            },
            basicInfoApplicationConfirm(e) {
                di.router.push('/info/basic-information-application-confirm');
            },
            reload(data) {
                this.state = data;
                if (!this.state.bank_account) this.state.bank_account = {status: 0};
                if (!this.state.basic_information) this.state.basic_information = {};
                if (!this.state.eligible_invoice_provider) this.state.eligible_invoice_provider = {state: 0}; //データが取れない場合、初期値＝state=0に戻す
                if (Object.keys(this.state.basic_information).length > 0) {
                    this.nodata = false;
                    this.app = (this.state.basic_information.application);
                } else {
                    this.nodata = true;
                }


                this.update();
            },
            onBeforeMount() {
                this.api = di.createApi('info');
                this.api.request('index', 'fetch')
                    .then(data => this.reload(data));
            }
        }
    </script>
</info-index-tag>
